<template>
  <b-card class="rounded">
    <b-row>
      <b-col class="col-4">
        <div
          class="hp-sidebar hp-bg-color-black-20 hp-bg-color-dark-90 border-right hp-border-color-black-40 hp-border-color-dark-80"
        >
          <div class="hp-sidebar-container">
            <div class="hp-sidebar-header-menu">
              <sidebar-header />
              <ul>
                <sidebar-item :item="sidebarItem" />
              </ul>
            </div>

            <sidebar-footer />
          </div>
        </div>
      </b-col>

      <LegalCard v-if="this.$route.meta.card === 'legal'" />
      <PasswordCard v-else-if="this.$route.meta.card === 'password'" />
      <PersonalCard v-else />
      
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BButton,
  BLink,
  BCard,
  BInputGroup,
  BFormInput,
  BForm,
  BFormRow,
} from "bootstrap-vue";

import PersonalCard from "./cards/Personal.vue";
import LegalCard from "./cards/Legal.vue";
import PasswordCard from "./cards/Password.vue";
import SidebarHeader from "./header";
import SidebarItem from "./item";
import SidebarFooter from "./footer";
import navigation from "./routes";

export default {
  data() {
    return {
      sidebarItem: navigation,
      card: "",
    };
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BLink,
    BCard,
    SidebarHeader,
    SidebarItem,
    SidebarFooter,
    BInputGroup,
    BFormInput,
    BForm,
    BFormRow,
    PersonalCard,
    LegalCard,
    PasswordCard,
  },
};
</script>
